const vietnamese = {
  name: "Vietnamese",
  native_name: "Tiếng Việt",
  code: "vi",
};

const vi = {
  translation: {
    report_bug: "Báo cáo lỗi",
    import: "Nhập",
    file: "Tệp",
    new: "Tạo mới",
    new_window: "Tạo mới cửa sổ",
    open: "Mở",
    save: "Lưu",
    save_as: "Lưu thành",
    save_as_template: "Lưu thành mẫu",
    template_saved: "Mẫu được lưu!",
    rename: "Đổi tên",
    delete_diagram: "Xoá sơ đồ",
    are_you_sure_delete_diagram: "Bạn muốn xoá sơ đồ này không? Hành động này không thể phục hồi.",
    oops_smth_went_wrong: "Có cái gì đó bị sai.",
    import_diagram: "Nhập sơ đồ",
    import_from_source: "Nhập từ SQL",
    export_as: "Xuất thành",
    export_source: "Xuất SQL",
    models: "Mô hình",
    exit: "Thoát",
    edit: "Sửa",
    undo: "Quay lại",
    redo: "Làm lại",
    clear: "Xóa",
    are_you_sure_clear: "Bạn có chắc chắn muốn xóa sơ đồ không? Điều này là không thể phục hồi.",
    cut: "Cắt",
    copy: "Sao chép",
    paste: "Dán",
    duplicate: "Nhân bản",
    delete: "Xóa",
    copy_as_image: "Sao chép dưới dạng hình ảnh",
    view: "Xem",
    header: "Thanh menu",
    sidebar: "Thanh bên",
    issues: "Vấn đề",
    presentation_mode: "Chế độ trình bày",
    strict_mode: "Chế độ nghiêm ngặt",
    field_details: "Chi tiết trường",
    reset_view: "Đặt lại chế độ xem",
    show_grid: "Hiển thị lưới",
    show_cardinality: "Hiển thị số lượng",
    theme: "Chủ đề",
    light: "Sáng",
    dark: "Tối",
    zoom_in: "Phóng to",
    zoom_out: "Thu nhỏ",
    fullscreen: "Toàn màn hình",
    settings: "Cài đặt",
    show_timeline: "Hiển thị dòng thời gian",
    autosave: "Tự động lưu",
    panning: "Xoay",
    table_width: "Chiều rộng của bảng",
    language: "Ngôn ngữ",
    flush_storage: "Xoá bộ nhớ",
    are_you_sure_flush_storage: "Bạn có chắc chắn muốn xóa bộ nhớ không? Thao tác này sẽ xóa vĩnh viễn tất cả sơ đồ và mẫu tùy chỉnh của bạn.",
    storage_flushed: "Bộ nhớ đã được xoá",
    help: "Giúp đỡ",
    shortcuts: "Phím tắt",
    ask_on_discord: "Theo dõi chúng tôi trên Discord",
    feedback: "Nhận xét",
    no_changes: "Không thay đổi",
    loading: "Đang tải...",
    last_saved: "Đã lưu lần cuối",
    saving: "Đang lưu...",
    failed_to_save: "Lưu thất bại",
    fit_window_reset: "Đặt cửa số vừa độ rộng / Cài lại",
    zoom: "Phóng",
    add_table: "Thêm bảng",
    add_area: "Thêm vùng",
    add_note: "Thêm ghi chú",
    add_type: "Thêm loại",
    to_do: "Việc cần làm",
    tables: "Bảng",
    relationships: "Quan hệ",
    subject_areas: "Vùng",
    notes: "Ghi chú",
    types: "Loại",
    search: "Tìm kiếm...",
    no_tables: "Không có bảng",
    no_tables_text: "Bắt đầu xây dựng sơ đồ của bạn!",
    no_relationships: "Không có quan hệ",
    no_relationships_text: "Kéo để kết nối các trường và hình thành các quan hệ!",
    no_subject_areas: "Không có vùng",
    no_subject_areas_text: "Thêm vùng vào nhóm các bảng!",
    no_notes: "Không có ghi chú",
    no_notes_text: "Sử dụng ghi chú để ghi lại thông tin bổ sung",
    no_types: "Không có loại",
    no_types_text: "Tạo các loại dữ liệu tùy chỉnh của riêng bạn",
    no_issues: "Không có vấn đề nào được phát hiện.",
    strict_mode_is_on_no_issues: "Chế độ nghiêm ngặt bị tắt nên sẽ không có vấn đề nào được hiển thị.",
    name: "Tên",
    type: "Kiểu",
    null: "Không có giá trị",
    not_null: "Có giá trị",
    primary: "Chính",
    unique: "Duy nhất",
    autoincrement: "Tự động tăng",
    default_value: "Giá trị mặc định",
    check: "Kiểm tra biểu thức",
    this_will_appear_as_is: "*Điều này sẽ xuất hiện trong đoạn lệnh được tạo như hiện tại.",
    comment: "Bình luận",
    add_field: "Thêm trường",
    values: "Giá trị",
    size: "Kích cỡ",
    precision: "Độ chính xác",
    set_precision: "Đặt độ chính xác: (kích thước, chữ số)",
    use_for_batch_input: "Sử dụng , để nhập hàng loạt",
    indices: "Chỉ số",
    add_index: "Thêm chỉ mục",
    select_fields: "Chọn các trường",
    title: "Tiêu đề",
    not_set: "Không được thiết lập",
    foreign: "Ngoài",
    cardinality: "Quan hệ",
    on_update: "Khi cập nhật",
    on_delete: "Khi xóa",
    swap: "Tráo đổi",
    one_to_one: "Một đối một",
    one_to_many: "Một đến nhiều",
    many_to_one: "Nhiều thành một",
    content: "Nội dung",
    types_info: "Tính năng này dành cho các DBMS quan hệ đối tượng như PostgreSQL.\nNếu được sử dụng cho MySQL hoặc MariaDB, loại JSON sẽ được tạo bằng kiểm tra xác thực json tương ứng.\nNếu được sử dụng cho SQLite, nó sẽ được dịch sang BLOB.\nNếu được sử dụng cho MSSQL một bí danh loại cho trường đầu tiên sẽ được tạo.",
    table_deleted: "Đã xóa bảng",
    area_deleted: "Khu vực bị xóa",
    note_deleted: "Đã xóa ghi chú",
    relationship_deleted: "Đã xóa quan hệ",
    type_deleted: "Loại đã xóa",
    cannot_connect: "Không thể kết nối, các cột có nhiều loại khác nhau",
    copied_to_clipboard: "Sao chép vào clipboard",
    create_new_diagram: "Tạo sơ đồ mới",
    cancel: "Hủy bỏ",
    open_diagram: "Mở sở đồ",
    rename_diagram: "Đổi tên sơ đồ",
    export: "Xuất",
    export_image: "Xuất hình ảnh",
    create: "Tạo",
    confirm: "Xác nhận",
    last_modified: "Sửa đổi lần cuối",
    drag_and_drop_files: "Kéo và thả tệp vào đây hoặc nhấp để tải lên.",
    support_json_and_ddb: "Các tệp JSON và DDB được hỗ trợ",
    upload_sql_to_generate_diagrams: "Tải tệp sql lên để tự động tạo bảng và cột của bạn.",
    overwrite_existing_diagram: "Ghi đè sơ đồ hiện có",
    only_mysql_supported: "*Hiện tại, chỉ hỗ trợ tải các tập lệnh MySQL.",
    blank: "Trống",
    filename: "Tên tập tin",
    table_w_no_name: "Khai báo một bảng không có tên",
    duplicate_table_by_name: "Bảng trùng lặp theo tên '{{tableName}}'",
    empty_field_name: "Trường trống `name` trong bảng '{{tableName}}'",
    empty_field_type: "Trường trống `loại` trong bảng '{{tableName}}'",
    no_values_for_field: "Trường '{{fieldName}}' của bảng '{{tableName}}' thuộc loại `{{type}}` nhưng không có giá trị nào được chỉ định",
    default_doesnt_match_type: "Giá trị mặc định cho trường '{{fieldName}}' trong bảng '{{tableName}}' không khớp với loại của nó",
    not_null_is_null: "Trường '{{fieldName}}' của bảng '{{tableName}}' là NOT NULL nhưng đang là NULL",
    duplicate_fields: "Các trường bảng trùng lặp theo tên '{{fieldName}}' trong bảng '{{tableName}}'",
    duplicate_index: "Chỉ mục trùng lặp theo tên '{{indexName}}' trong bảng '{{tableName}}'",
    empty_index: "Chỉ mục trong bảng '{{tableName}}' chỉ mục không có cột",
    no_primary_key: "Bảng '{{tableName}}' không có khóa chính",
    type_with_no_name: "Khai báo một loại không có tên",
    duplicate_types: "Các loại trùng lặp theo tên '{{typeName}}'",
    type_w_no_fields: "Đã khai báo một loại trống '{{typeName}}'không có trường nào",
    empty_type_field_name: "Trường trống `name` trong loại '{{typeName}}'",
    empty_type_field_type: "Trường trống `type` trong loại '{{typeName}}'",
    no_values_for_type_field: "Trường '{{fieldName}}' thuộc loại '{{typeName}}' thuộc loại `{{type}}` nhưng không có giá trị nào được chỉ định",
    duplicate_type_fields: "Các trường loại trùng lặp theo tên '{{fieldName}}' trong loại '{{typeName}}'",
    duplicate_reference: "Tham chiếu trùng lặp theo tên '{{refName}}'",
    circular_dependency: "Bảng phụ thuộc vòng tròn liên quan đến '{{refName}}'",
    timeline: "Dòng thời gian",
    priority: "Độ ưu tiên",
    none: "Không có",
    low: "Thấp",
    medium: "Trung bình",
    high: "Cao",
    sort_by: "Sắp xếp theo",
    my_order: "Thứ tự của tôi",
    completed: "Thứ tự hoàn thành",
    alphabetically: "Thứ tự bảng chữ cái",
    add_task: "Thêm nhiệm vụ",
    details: "Chi tiết",
    no_tasks: "Bạn chưa có nhiệm vụ nào.",
    no_activity: "Bạn chưa có hoạt động nào.",
    move_element: "Di chuyển {{name}} tới {{coords}}",
    edit_area: "{{extra}} Chỉnh sửa khu vực {{areaName}}",
    delete_area: "Xóa khu vực {{areaName}}",
    edit_note: "{{extra}} Chỉnh sửa ghi chú {{noteTitle}}",
    delete_note: "Xóa ghi chú {{noteTitle}}",
    edit_table: "{{extra}} Chỉnh sửa bảng {{tableName}}",
    delete_table: "Xóa bảng {{tableName}}",
    edit_type: "{{extra}} Chỉnh sửa loại {{typeName}}",
    delete_type: "Xóa loại {{typeName}}",
    add_relationship: "Thêm quan hệ",
    edit_relationship: "{{extra}} Chỉnh sửa quan hệ {{refName}}",
    delete_relationship: "Xóa quan hệ {{refName}}",
    not_found: "Không tìm thấy",
  },
};

export { vi, vietnamese };
